import { render, staticRenderFns } from "./SearchItem.vue?vue&type=template&id=6746aa9b&scoped=true"
import script from "./SearchItem.vue?vue&type=script&lang=js"
export * from "./SearchItem.vue?vue&type=script&lang=js"
import style0 from "./SearchItem.vue?vue&type=style&index=0&id=6746aa9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6746aa9b",
  null
  
)

export default component.exports